module.exports = __webpack_public_path__ + "media/ai_video_anime2.88110a3d.mp4";